import * as React from "react";
import { ImageProps, WithClassNames } from "../models";

export const ImageView: React.FC<ImageProps & WithClassNames> = (props) => (
	<img src={props.source} alt={props.source} className={props.className} />
);
